module.exports = __webpack_public_path__ + "media/assets/images/flags/mq-7989e288986cbde60d8800c3d8cdfa5f.svg";